/* import __COLOCATED_TEMPLATE__ from './mobile-large.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();